module.exports = __webpack_public_path__ + "img/image-lateral.ae245912.png";